// global.SET_API_URL = 'http://localhost:5000/'

global.SET_API_URL = 'https://server.lb.whdevs.com/'

// global.SET_API_URL = 'http://98.90.41.32:5001/'

// global.SET_API_URL = 'http://192.168.10.2:5000/'

// global.SET_API_URL = 'http://192.168.10.5:5000/'

// global.SET_API_URL = 'http://192.168.100.142:5000/'

// global.SET_API_URL = 'http://192.168.0.107:5000/'

// global.SET_API_URL = 'https://server-nms.whdevs.com/'

// global.SET_API_URL = 'http://52.207.98.97:5000/'

// global.SET_API_URL = 'https://server-ts.inv.whdevs.com/'

global.COMPANY_NAME = 'WORLD HOME DEVELOPMENT'

global.targetDate = new Date()
